import React from "react";
import wostep from "../assets/wostep-logo.png";
import { Link } from "react-router-dom";

function Program({
  id,
  length,
  description,
  focus,
  subdescription,
  requirements,
  link,
}) {
  return (
    <div className={`bg-white w-full flex flex-col md:ml-10 relative mb-20`}>
      {id === "1" ? (
        <img
          className="w-[110px] mt-8"
          src={wostep}
          alt="WOSTEP logo"
        />
      ) : null}

      <div className={` ${id === "1" ? "mt-4" : ""}`}>
        <p className="text-[16px]">{length}</p>
        <p className="mt-[30px] max-w-[900px]">{description}</p>
        {subdescription && (
          <>
            <p className="mt-[30px] max-w-[900px]">{subdescription}</p>
          </>
        )}
        <br />
        {focus && (
          <>
            <p className="uppercase mb-4 mt-2 text-sm">{focus.description}</p>
            <ul className="list-disc list-inside ml-6">
              {focus.bullets.map((bullet, idx) => {
                if (typeof bullet !== "string") {
                  const parentBullet = Object.keys(bullet)[0];
                  const subBullets = Object.values(bullet)[0];
                  return (
                    <React.Fragment key={`bullet_${idx}`}>
                      <li>
                        {parentBullet}{" "}
                        <ul className="list-disc list-inside ml-6">
                          {subBullets.map((sub) => {
                            return <li key={`sub-bullet_${idx}`}>{sub}</li>;
                          })}
                        </ul>
                      </li>
                    </React.Fragment>
                  );
                } else {
                  return <li key={`bullet_${idx}`}>{bullet}</li>;
                }
              })}
            </ul>
            <br />
          </>
        )}
        {requirements ? (
          <div className="bg-[#e5e7eb50] p-6">
            <p className="uppercase mb-4 mt-2 text-sm font-bold">
              Requirements:
            </p>
            <ul className="list-disc list-inside ml-2">
              {requirements.map((req, idx) => (
                <li key={`req_${idx}`}>{req}</li>
              ))}
            </ul>
            <div className="w-full text-center ml-4 mt-6 flex justify-start">
              <Link
                to="/apply"
                className="uppercase w-max py-4 px-6 md:px-16 text-sm bg-transparent border border-black text-black hover:text-white hover:bg-black transition-colors duration-500"
                aria-label="link to apply"
              >
                Apply now
              </Link>
            </div>
          </div>
        ) : (
          <div>
            <div className="w-full text-center mt-6 flex justify-start">
              <Link
                to="/apply"
                className="uppercase w-max py-4 px-16 text-sm bg-transparent border border-black text-black hover:text-white hover:bg-black transition-colors duration-750"
                aria-label="link to apply"
              >
                Apply now
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Program;
